import React from 'react';
import Posts from './Posts';

const KnowledgeBase = () => {
  return <Posts type="Draft" title="Drafts" />;
};

export default KnowledgeBase;
